import * as React from 'react';
import withStyles from 'react-jss';
import { connect } from 'react-redux';
import Form from 'antd/lib/form';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Select from 'antd/lib/select';
import message from 'antd/lib/message';
import Tooltip from 'antd/lib/tooltip';
import Checkbox from 'antd/lib/checkbox';
import InputNumber from 'antd/lib/input-number';
import DatePicker from 'antd/lib/date-picker';
import Collapse from 'antd/lib/collapse';
import Input from 'antd/lib/input';
import Timeline from 'antd/lib/timeline';
import Icon from 'antd/lib/icon';
import Spin from 'antd/lib/spin';
import { getPorts } from 'src/api/containerTracking';
import { CargoType } from './Booking/BookingUtils';
import { useGenericState } from 'src/Library/UseGenericState';
import { isValidArray, getPropertyValue } from 'src/Library/Helper';
import AddLocationModal from './Modals/AddLocationModal';
import AddCfsLocationModal from './Modals/AddCfsLocationModal';
import { LocationPreferences, termsConditionsPlaceholder, disableInquiryClosingTimeUtil, productTempValidation, disableInquiryClosingDateUtil } from './InquiryUtils';
import { InquiryType, InquiryModes, CargoOperationType, LocationType } from 'src/Library/Constants';
import { useDebounce } from 'src/hooks/useDebounce';
import { renderSelectDropDown } from 'src/Library/Common';
import { KeyLabel } from 'src/Library/Types';
import moment, { Moment } from 'moment';
 
import { Ports } from 'src/components/common/Types/CommonTypes';
import { fetchAddresses } from 'src/api/organisationProfiling';
import { renderAddressDetails, getCountryId } from './Cards/InquiryCommon';
import { prefillTruckingLocationDetails } from 'src/api/inquiry';
import isEmpty from 'lodash/isEmpty';
import { Radio } from 'antd';
const { RangePicker } = DatePicker;
import SelectAddress from 'src/components/common/CommonSelect/SelectAddress';
import { EXCLUDED_WEIGHT_UNITS } from './constants';
import { hasMasterCategoryEditPermission } from 'src/utils/partsToShow/helper';
import { tokens } from 'src/design-system';
import Asterisk from 'src/components/common/Asterisk';

const styles = (theme) => ({
  cargoWeight: {
    border: 'none',
    boxShadow: 'none',
  },
  cargoWeightType: {
    '& .ant-select-selection': {
      border: 'none',
      boxShadow: 'none',
    },
  },
  additionalDetailsRow: {
    marginBottom: '20px',
    display: 'flex',
    justifyContent: 'center',
    marginRight: '30px',
    verticalAlign: 'middle',
  },
  dot: {
    height: '8px',
    width: '8px',
    borderRadius: '5px',
    border: '1px solid #979797',
  },
  dotFilled: {
    backgroundColor: 'rgb(217, 217, 217)',
  },
  fontItalic: {
    color: '#666666',
    fontSize: `${tokens.fontSize.small}px`,
    fontStyle: 'italic',
    lineHeight: '6px',
  },
  checkboxFont: {
    fontSize: `${tokens.fontSize.caption}px`,
    fontWeight: tokens.fontWeight.semibold,
    color: '#666666',
  },
  selectBorder: {
    '& .ant-select-selection': {
      border: 'none',
      boxShadow: 'none',
    },
  },
  cargoColumn: {
    border: '1px solid #D9D9D9',
    borderRadius: `${tokens.radius.md}px`,
    height: '32px',
    display: 'flex',
    paddingRight: 0,
  },
  cargoFontItem: {
    '& .ant-form-item-control': {
      lineHeight: '30px',
    },
  },
  addNewSelect: {
    display: 'flex',
    flexWrap: 'nowrap',
    color: tokens.colors.primary,
    padding: '6px 6px 10px',
  },
  locationType: {
    border: '1px solid #FFC83C',
    padding: '2px',
    borderRadius: '7px',
    marginTop: '8px',
    backgroundColor: '#FFFBD0',
    height: '100%',
    fontSize: '8px',
  },
  addressCard: {
    whiteSpace: 'break-spaces',
    fontSize: `${tokens.fontSize.caption}px`,
    color: tokens.colors.textSecondary,
    lineHeight: '12px',
  },
  stuffingDropdown: {
    '& .ant-select-dropdown-menu-item:not(:last-child)': {
      borderBottom: '1px solid #EDEDED',
      paddingBottom: '6px',
    },
  },
});

interface StateProps {
  vehicleDetails: any [];
  activeKey?: string | string[];
  openNewLocationModal: boolean;
  openCFSLocationModal: boolean;
  searchTerm: string;
  isPortSearching: boolean;
  ports: Ports [];
  cfsAddresses: any [];
  isAddressLoading: boolean;
  cfsLocation: any;
  isPrefilling?: boolean;
  prefillData?;
  countrySelected: string;
  stuffingAddresses;
  deStuffingAddresses;
  cargoReadyDate: moment.Moment | null;
  preferredSailingRange: [
    Moment,
    Moment,
  ];
}

const Option = Select.Option;
const FormItem = Form.Item;

const CreateTruckingInquiry = (props) => {
  const {
    parentClasses,
    form,
    classes,
    cargoTypes,
    cargoList,
    currencies,
    trailerType,
    vehicleTypeSizeList,
    orgMaster,
    organisationId,
    shipperId,
    setStuffingTruckingAddress,
    stuffingAddressObj,
    loadAddresses,
    cfsAddressesList,
    weightsUnits,
    termsAndConditions,
    businessEntities,
    businessTypeList,
    prefilling,
    prefilledVehicleDetails,
    prefilledCfsLocation,
    isBooking,
    inquiryId,
    isEdit,
    stuffingAddressesList,
    deStuffingAddressesList,
    selectedCountryId,
    prefilledTermsAndConditions,
    isTemperatureControlledMandatory,
    reeferProductTempRange,
    defaultDeadlineInHours,
    defaultVehicleSpecificTnC,
    defaultMovementSpecificTnC,
    defaultWeights,
    isGensetRequired,
    customFieldsForInquiryTrailer,
    draftMandatoryFields,
  } = props;
  const { getFieldDecorator, getFieldValue, setFieldsValue } = form;
  const [state, setState] = useGenericState<StateProps>({
    vehicleDetails: [{ }],
    activeKey: undefined,
    openNewLocationModal: false,
    openCFSLocationModal: false,
    searchTerm: '',
    isPortSearching: false,
    ports: [],
    cfsAddresses: cfsAddressesList,
    isAddressLoading: true,
    cfsLocation: {},
    countrySelected: selectedCountryId,
    stuffingAddresses: stuffingAddressesList,
    deStuffingAddresses: deStuffingAddressesList,
    cargoReadyDate: moment(),
    preferredSailingRange: [
      moment().endOf('day').add(7, 'day'),
      moment().endOf('day').add(14, 'day'),
    ],
  });

  const {
    vehicleDetails,
    activeKey,
    openNewLocationModal,
    openCFSLocationModal,
    searchTerm,
    isPortSearching,
    ports,
    cfsAddresses,
    isAddressLoading,
    cfsLocation,
    isPrefilling,
    prefillData,
    countrySelected,
    stuffingAddresses,
    deStuffingAddresses,
    cargoReadyDate,
    preferredSailingRange,
  } = state;

  React.useEffect(() => {
    if (!prefilling) {
      setState({
        vehicleDetails: prefilledVehicleDetails || [{ }],
        cfsLocation: prefilledCfsLocation,
      });
    }
    const pickupPortCode = JSON.parse(getFieldValue('pickupPort')?.key || '{}')?.code;
    const dropOffPortCode = JSON.parse(getFieldValue('dropOffPort')?.key || '{}')?.code;
    const cargoReadyDate = getFieldValue('cargoDate');
    if (cargoReadyDate)
      setState({cargoReadyDate: moment(cargoReadyDate)})
    const preferredSailingRange = getFieldValue('preferredSailingRange');
    if (preferredSailingRange)
      setState({ preferredSailingRange });
    setContainerDropOffCheck(pickupPortCode, dropOffPortCode);
  }, [prefilling]);

  const disableInquiryClosingDate = (current) => {
    let condition = disableInquiryClosingDateUtil(current);
    return (
      condition ||
      (preferredSailingRange?.[1] &&
        current &&
        current > state.preferredSailingRange[1].clone().endOf('day'))
    );
  }

  const setContainerDropOffCheck = (pickupPortCode, dropOffPortCode) => {
    if (!prefilling && pickupPortCode && pickupPortCode === dropOffPortCode &&
      trailerType === InquiryType.EXPORT) {
      setFieldsValue({ containerDropOffCheck: true });
    } else {
      setFieldsValue({ containerDropOffCheck: false });
    }
  }

  React.useEffect(() => {
    if (!isBooking && !isEdit && !inquiryId) {
      prefillDataInForm();
    }
    if (!prefilling) {
      setStuffingTruckingAddress(undefined);
      setState({ cfsLocation: undefined });
      // if all the location fields are empty on changing trailer type, country selected should reset
      if (
        !form.getFieldValue('stuffingAddress') &&
        !form.getFieldValue('deStuffingAddress') &&
        !form.getFieldValue('dropOffPort') &&
        !form.getFieldValue('cfsLocation') &&
        !form.getFieldValue('pickupPort')
      ) {
        setState({ countrySelected: undefined });
      }
    }
  }, [trailerType]);

  const disableTruckingCargoReadyDate = (current) => {
    return current && current < moment().startOf('day') && (current < moment(cargoReadyDate).startOf('day'))
  }

  const prefillDataInForm = async () => {
    const { updateDisableModeSwitch } = props;
    if (isEmpty(prefillData)) {
      setState({ isPrefilling: true });
      updateDisableModeSwitch(true);
      const response = await prefillTruckingLocationDetails();
      if (response.isSuccess) {
        prefillTruckingValues(response.data);
        setState({ prefillData: response.data, isPrefilling: false });
        updateDisableModeSwitch(false);
      } else {
        setState({ isPrefilling: false });
        updateDisableModeSwitch(false);
      }
    } else {
      prefillTruckingValues(prefillData);
    }
  }

  const prefillTruckingValues = (data) => {
    if (isEmpty(data)) return;
    const locationData = data[trailerType];
    const destuffingocationDetails = InquiryType.EXPORT ?
      locationData.originLocationDetails : locationData.destinationLocationDetails
      setStuffingTruckingAddress({
      city: destuffingocationDetails?.city,
      countryId: destuffingocationDetails?.countryId,
      address: destuffingocationDetails?.address,
      state: destuffingocationDetails?.state,
      pincode: destuffingocationDetails?.pincode,
      name: destuffingocationDetails?.name,
    });
    let countryId;
    if (trailerType === InquiryType.EXPORT) {
      form.setFieldsValue({
        pickupPort: locationData.emptyContainerLocationPortDetails ? {
          key: JSON.stringify(locationData.emptyContainerLocationPortDetails || '{}'),
          label: `${locationData.emptyContainerLocationPortDetails?.name}
          [${locationData.emptyContainerLocationPortDetails?.code}]`,
        } : undefined,
        dropOffPort: locationData.destinationPortDetails ? {
          key: JSON.stringify(locationData.destinationPortDetails || '{}'),
          label: `${locationData.destinationPortDetails?.name} [${locationData.destinationPortDetails?.code}]`,
        } : undefined,
        stuffingAddress: {
          key: locationData.originLocationDetails?.id,
          label: `${locationData.originLocationDetails?.name}, ${locationData.originLocationDetails?.pincode ?? ''} (${locationData.originLocationDetails?.referenceNumber})`
        },
        cargoType: locationData.cargoType ?? undefined,
        product: locationData.productType ?? undefined,
      });
      countryId = getCountryId(
        [
          locationData.emptyContainerLocationPortDetails,
          locationData.destinationPortDetails,
          locationData.originLocationDetails,
        ],
      );
    } else {
      form.setFieldsValue({
        cfsLocation: {
          key: locationData.originLocationDetails?.id,
          label: `${locationData.originLocationDetails?.name}, ${locationData.originLocationDetails?.pincode ?? ''} (${locationData.originLocationDetails?.referenceNumber})`
        },
        dropOffPort: locationData.emptyContainerLocationPortDetails ? {
          key: JSON.stringify(locationData.emptyContainerLocationPortDetails || '{}'),
          label: `${locationData.emptyContainerLocationPortDetails?.name}
          [${locationData.emptyContainerLocationPortDetails?.code}]`,
        } : undefined,
        deStuffingAddress: {
          key: locationData.destinationLocationDetails?.id,
          label: `${locationData.destinationLocationDetails.name}, ${locationData.destinationLocationDetails.pincode ?? ''} (${locationData.destinationLocationDetails.referenceNumber})`,
        },
        cargoType: locationData.cargoType ?? undefined,
      },
      () => {
        setFieldsValue({
          product: locationData.productType ?? undefined,
        })
      });
      countryId = getCountryId(
        [
          locationData.originLocationDetails,
          locationData.emptyContainerLocationPortDetails,
          locationData.destinationLocationDetails,
        ]
      );
    }
    setState({
      countrySelected: countryId,
      cfsLocation: trailerType === InquiryType.IMPORT ? locationData.originLocationDetails : cfsLocation,
      vehicleDetails: locationData?.containerDetails || [{ }],
    });
    setContainerDropOffCheck(locationData.emptyContainerLocationPortDetails?.code,
      locationData.destinationPortDetails?.code);
  }

  const getInitialVehicleDetails = (index, propertyKey, weightType: string | undefined=undefined) => {
    if (weightType && defaultWeights?.TRAILER) {
      const vehicleInfo = getFieldValue(`vehicleDetails[${index}].size`)+ ' ' + getFieldValue(`vehicleDetails[${index}].type`).split(' ')[0];
      const loc = getFieldValue('dropOffPort');
      return loc?.key ? defaultWeights?.TRAILER?.[vehicleInfo]?.[weightType]?.[JSON.parse(loc.key).code] : undefined;
    }
    if ((isValidArray(vehicleDetails) && vehicleDetails[index])) {
      return getPropertyValue(vehicleDetails[index], propertyKey);
    }
  };

  const searchPorts = async (queryString) => {
    const response = await getPorts({
      queryString,
      type: ['DRY', 'WET'],
      countryIdList: countrySelected ? [countrySelected] : [],
    });
    if (response.isSuccess) {
      setState({
        ports: response.data?.map(item => ({
          ...item,
          id: JSON.stringify({
            ...item,
            id: item.dbId,
          }),
        })),
        isPortSearching: false,
      });
    } else {
      message.error(response.errorMessage);
      setState({
        ports: [],
        isPortSearching: false,
      });
    }
  };

  const debouncedSearchTerm = useDebounce(searchTerm, 300);
  const disablePastDate = (current: any) => {
    return current && current < moment().endOf('day');
  };

  React.useEffect(
    () => {
      setState({
        isPortSearching: true,
      });
      searchPorts(debouncedSearchTerm);
    },
    [debouncedSearchTerm || countrySelected],
  );

  const getProductOptions = () => {
    const cargoTypeSelected = CargoType.REEFER;
    const productList =
      isValidArray(cargoList) &&
      cargoList.filter((cargo) => cargo.key?.cargo === cargoTypeSelected);

    return (
      isValidArray(productList) &&
      productList.map(
        (item) =>
          item.showAlways && (
            <Option key={item.label?.product} data-value={item.label?.product}>
              {item.label?.product}
            </Option>
          )
      )
    );
  };

  const renderAddressCard = (item, ind, showLabel = true) => {
    return (
      <>
        <div style={{ display: 'flex', lineHeight: '10px', justifyContent: 'space-between' }}>
          <span style={{ fontSize: `${tokens.fontSize.body}px`, margin: '8px 0 8px', fontWeight: 600 }}>
            {`${item.name} (${item.referenceNumber})`}
          </span>
          {showLabel && <span className={classes.locationType}
          style={{
            backgroundColor: LocationPreferences[item.location] === LocationPreferences.CFS
              ? '#F0EBFF' : '#FFFBD0',
            borderColor: LocationPreferences[item.location] === LocationPreferences.CFS
              ? '#AE90FF' : '#FFC83C',
          }}>{LocationPreferences[item.location]}</span>}
        </div>
        {renderAddressDetails({
          item,
          orgMaster,
          classes,
        })}
      </>
    );
  };

  const getFilterVehicleTypesSize = (labelValue) => {
    const filteredList: any = [];
    vehicleTypeSizeList.filter((container) => {
      if (!filteredList?.some((item) => item?.key[labelValue] === container?.key[labelValue])) {
        if (container?.canUse) {
          filteredList.push(container);
        }
      }
    });
    return filteredList;
  };

  const renderCargoReadyOrClosingTime = (title, fieldLabel, apiKey, initialValue?) => {
    const isDraft = getFieldValue('isDraft');
    const isRequired = (isDraft && draftMandatoryFields?.includes(apiKey)) || !isDraft;
    
    return (
      <Row
        gutter={24}
        style={{
          marginBottom: '10px',
          marginRight: '10px',
          verticalAlign: 'middle',
        }}
      >
        <Col
          span={5}
          style={{
            whiteSpace: fieldLabel === 'cargoDate' ? 'nowrap' : 'break-spaces',
            marginTop: '10px',
            lineHeight: '16px',
          }}
        >
          <span className={parentClasses.formTitles} style={{ lineHeight: '16px' }}>{title}{isRequired ? <Asterisk /> : null}</span>
        </Col>
        <Col span={19}>
          <FormItem style={{ width: '50%', marginBottom: 0 }}>
            {getFieldDecorator(fieldLabel, {
              rules: [{ required: isRequired, message: 'Required' }],
              initialValue: isRequired ? initialValue : undefined,
            })(
              <DatePicker
                showTime={fieldLabel !== 'cargoDate' && {
                  defaultValue: moment('23:59', 'HH:mm'),
                }}
                disabledDate={fieldLabel !== 'cargoDate' ? disableInquiryClosingDate : disableTruckingCargoReadyDate}
                disabledTime={fieldLabel !== 'cargoDate' ? disableInquiryClosingTimeUtil : undefined}
                allowClear
                disabled={isPrefilling}
                style={{ width: '100%' }}
                format={fieldLabel === 'cargoDate' ? 'DD MMM YYYY' : 'DD MMM YYYY | HH:mm'}
                placeholder={fieldLabel === 'cargoDate' ? 'Cargo Ready Date' : 'Inquiry Closing Time'}
                onChange = {(newDate) => {
                  if (fieldLabel === 'cargoDate')
                    setState({cargoReadyDate: newDate});
                }}
              />
            )}
          </FormItem>
        </Col>
      </Row>
    );
  };
const renderGensetRequired = () => {
  const isDraft = form.getFieldValue('isDraft');
  const isRequired = (isDraft && draftMandatoryFields?.includes('isGensetRequired')) || !isDraft;
    
  return (
    <Row
    gutter={24}
    style={{
      marginBottom: '10px',
      marginRight: '10px',
      verticalAlign: 'middle',
    }}
  >
    <Col
      span={5}
      style={{
        marginTop: '10px',
        lineHeight: '16px',
      }}
    >
    <span className={parentClasses.formTitles} style={{ width: '23%' }}>
        Genset Required{isRequired ? <Asterisk /> : null}
    </span>
    </Col>
    <Col span={19}>
      <FormItem style={{ width: '50%', marginBottom: 0 }}>
      {getFieldDecorator("isGensetRequired", {initialValue: isRequired ? true : undefined })(
          <Radio.Group>
          <Radio value={true}>Yes</Radio>
          <Radio value={false}>No</Radio>
        </Radio.Group>
        )}
      </FormItem>
    </Col>
  </Row>
  );
};
const renderOverWeight = () => {
  const isDraft = form.getFieldValue('isDraft');
  const isRequired = (isDraft && draftMandatoryFields?.includes('overWeight')) || !isDraft;

  return (
    <Row
      gutter={24}
      style={{
        marginBottom: '10px',
        marginRight: '10px',
        verticalAlign: 'middle',
      }}
    >
      <Col
        span={5}
        style={{
          marginTop: '10px',
          lineHeight: '16px',
        }}
      >
        <span className={parentClasses.formTitles} style={{ width: '80%' }}>
          Over Weight{isRequired ? <Asterisk /> : null}
        </span>
      </Col>
      <Col span={15} style={{ display: 'flex', alignItems: 'center',}}>
        <FormItem
        >
          {getFieldDecorator(`overWeight.value`, {
            rules: [{ required: isRequired, message: 'Required' }],
            initialValue: getInitialVehicleDetails(0, '', isRequired ? 'overWeight' : undefined) || 0, 
            // base overweight value on first vehicle details
          })(
            <InputNumber
            type='number'
              min={0}
              style={{ width: '150px' }}
            />
          )}
        </FormItem>
        <FormItem style={{ width: '20%' }} className={classes.cargoFontItem}>
          {getFieldDecorator(`overWeight.unit`, {
            rules: [{ required: isRequired, message: 'Required' }],
            initialValue: 'mt',
          })(
            <div style={{ 
              border: '1px solid #D9D9D9',
              borderRadius: `${tokens.radius.md}px`,
            }}>
            <Select
              placeholder="Unit"
              allowClear={false}
              size="small"
              disabled={isBooking || isPrefilling}
              style={{ width: '100%' }}
              className={classes.selectBorder}
              defaultValue="mt"
              dropdownMatchSelectWidth={false}
            >
              {weightsUnits?.map((unit) => {
                // Skipping "cases" unit as it is required only in containerUnits
                if (EXCLUDED_WEIGHT_UNITS.includes(unit)) {
                  return null;
                } else {
                  return (
                    <Option key={unit}>{unit}</Option>
                  );
                }
              })}
            </Select>
            </div>
          )}
        </FormItem>
      </Col>
    </Row>
  );
};

const renderCustomRadio = (name, key, isMandatory=false, initialValue=undefined) => {
  return (
    <Row
      gutter={24}
      style={{
        marginBottom: '10px',
        marginRight: '10px',
        verticalAlign: 'middle',
      }}
    >
      <Col
        span={5}
        style={{
          marginTop: '10px',
          lineHeight: '16px',
        }}
      >
      <span className={parentClasses.formTitles} style={{ width: '23%' }}>
          {name}{isMandatory ? <Asterisk /> : null}
      </span>
      </Col>
      <Col span={19}>
        <FormItem style={{ width: '50%', marginBottom: 0 }}>
          {getFieldDecorator(`${key}`, {
            rules: [
              {
                required: isMandatory,
                message: 'Required!',
              },
            ],
            initialValue,
          })(
            <Radio.Group 
              disabled={isBooking}
              style={{ width: '100%' }}
            >
              <Radio value={true}>Yes</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          )}
        </FormItem>
      </Col>
    </Row>
  );
};

const renderCustomTextField = (name, key, isMandatory=false, initialValue=undefined) => {
  return (
    <Row
      gutter={24}
      style={{
        marginBottom: '10px',
        marginRight: '10px',
        verticalAlign: 'middle',
      }}
    >
      <Col
        span={5}
        style={{
          marginTop: '10px',
          lineHeight: '16px',
        }}
      >
      <span className={parentClasses.formTitles} style={{ width: '23%' }}>
          {name}{isMandatory ? <Asterisk /> : null}
      </span>
      </Col>
      <Col span={19}>
        <FormItem style={{ width: '50%', marginBottom: 0 }}>
          {getFieldDecorator(`${key}`, {
            rules: [
              {
                required: isMandatory,
                message: 'Required!',
              },
            ],
            initialValue,
          })(
            <Input
              disabled={isBooking}
              style={{ width: '100%' }}
              placeholder={name}
            />
          )}
        </FormItem>
      </Col>
    </Row>
  );
};

const renderCustomDropDown = (name, key, values=[], isMandatory=false, initialValue=undefined) => {
  return (
    <Row
      gutter={24}
      style={{
        marginBottom: '10px',
        marginRight: '10px',
        verticalAlign: 'middle',
      }}
    >
      <Col
        span={5}
        style={{
          marginTop: '10px',
          lineHeight: '16px',
        }}
      >
      <span className={parentClasses.formTitles} style={{ width: '23%' }}>
          {name}{isMandatory ? <Asterisk /> : null}
      </span>
      </Col>
      <Col span={19}>
        <FormItem style={{ width: '50%', marginBottom: 0 }}>
          {getFieldDecorator(`${key}`, {
            rules: [
              {
                required: isMandatory,
                message: 'Required!',
              },
            ],
            initialValue,
          })(
            <Select 
              disabled={isBooking} 
              allowClear 
              style={{ width: '100%' }}
              placeholder={name}>
              {values.length && values.map((value: string) => (
                <Select.Option key={value} data-value={value}>{value}</Select.Option>
              ))}
            </Select>
          )}
        </FormItem>
      </Col>
    </Row>
  );
};

  const renderContractDuration = () => {
    const isDraft = form.getFieldValue('isDraft');
    const isRequired = (isDraft && draftMandatoryFields?.includes('preferredSailingRange')) || !isDraft;
    
    return (
      <Row
        gutter={24}
        style={{
          marginBottom: '10px',
          marginRight: '10px',
          verticalAlign: 'middle',
        }}
      >
        <Col
          span={5}
          style={{
            marginTop: '10px',
            lineHeight: '16px',
          }}
        >
        <span className={parentClasses.formTitles} style={{ width: '23%' }}>
            Contract Duration{isRequired ? <Asterisk /> : null}
        </span>
        </Col>
        <Col span={19}>
          <FormItem style={{ width: '50%', marginBottom: 0 }}>
            {getFieldDecorator('preferredSailingRange', {
              rules: [
                {
                  required: isRequired,
                  message: 'Contract Duration is required',
                },
              ],
              initialValue: isRequired ? [
                moment().endOf('day').add(7, 'day'),
                moment().endOf('day').add(14, 'day'),
              ] : undefined,
            })(
              <RangePicker
                disabled={isBooking}
                allowClear
                disabledDate={disablePastDate}
                format="DD MMM YYYY"
                style={{ width: '100%' }}
                onChange={(date: [Moment, Moment]) => {
                  setState({
                    preferredSailingRange: date,
                  });
                }}
              />
            )}
          </FormItem>
        </Col>
      </Row>
    );
  };

  const renderCargoDetails = () => {
    let product = getFieldValue('product');
    const productObj = cargoList.find((cargo) => cargo.label.product === product);
    product = productObj?.key?.product;
    const showProductTempField = isTemperatureControlledMandatory && getFieldValue('cargoType') === CargoType.REEFER;
    const isDraft = form.getFieldValue('isDraft');
    const isRequired = (isDraft && draftMandatoryFields?.includes('cargoType')) || !isDraft;
    
    return (
      <Row
        gutter={24}
        style={{
          marginBottom: '10px',
          marginRight: '10px',
          verticalAlign: 'middle',
        }}
      >
        <Col span={5}>
          <div className={parentClasses.rowDiv}>
            <span className={parentClasses.formTitles}>Cargo{isRequired ? <Asterisk /> : null}</span>{' '}
          </div>
        </Col>
        <Col span={19} style={{ display: 'flex', flexDirection: 'column' }}>
          <div className={parentClasses.rowDiv}>
            <FormItem
              style={{ width: '50%', marginBottom: 0 }}
            >
              {getFieldDecorator('cargoType', {
                rules: [{ required: isRequired, message: 'Cargo type is required' }],
              })(
                <Select
                  placeholder="Cargo Type"
                  showSearch
                  allowClear={isDraft}
                  disabled={isBooking || isPrefilling}
                  dropdownMatchSelectWidth={false}
                >
                  {cargoTypes?.map((item) => {
                    return <Option key={item.key}>{item.label}</Option>;
                  })}
                </Select>
              )}
            </FormItem>
            {getFieldValue('cargoType') === CargoType.REEFER && (
              <FormItem
                style={{ marginLeft: '6px', width: showProductTempField ? '30%' : '50%', marginBottom: 0 }}
              >
                {getFieldDecorator('product', {
                  rules: [{ required: true, message: 'Product is required' }],
                })(
                  <Select
                    showSearch
                    disabled={isBooking || isPrefilling}
                    placeholder="Select Product"
                    style={{ width: '100%' }}
                    dropdownMatchSelectWidth={false}
                  >
                    {getProductOptions()}
                  </Select>
                )}
              </FormItem>
            )}
            {showProductTempField &&
              <React.Fragment>
                <Form.Item
                className={classes.formItemSmallError}
                style={{ marginLeft: '6px', width: '18%', marginBottom: 0 }}
              >
                {getFieldDecorator('temperatureControlled', {
                  rules: [
                    {
                      validator: (rule, value, cb) =>
                        productTempValidation(rule, value, cb, reeferProductTempRange, product)
                    }
                  ],
                })(
                  <InputNumber
                    type="number"
                    style={{ width: '100%' }}
                    precision={2}
                    placeholder="0"
                  /> 
                )}
              </Form.Item>
                <span style={{ margin: '8px 0 0 8px' }}>
                  °<span style={{ fontWeight: 600 }}>C</span>
                </span>
            </React.Fragment>}
          </div>
        </Col>
      </Row>
    );
  };

  const renderReferenceRate = () => {
    const { orgCurrency } = props;
    return (
      <div className={parentClasses.rowDiv} style={{ alignItems: 'center' }}>
        <div style={{ width: '25%' }}>
          <span className={parentClasses.formTitles}>Reference Rate </span>
        </div>
        <div style={{ width: '75%', display: 'flex', alignItems: 'center' }}>
          <FormItem style={{ marginBottom: '0px', width: '28%' }}>
            {getFieldDecorator("referenceRate.amount")(
              <InputNumber
                style={{ width: '100%' }}
                placeholder="Rate"
                disabled={isBooking || isPrefilling} />
            )}
          </FormItem>
          <FormItem style={{ marginBottom: '0px', width: '25%', marginLeft: '2px' }}>
            {getFieldDecorator("referenceRate.currency", {
              initialValue: orgCurrency,
            })(
              <Select
                style={{ width: '100%' }}
                dropdownMatchSelectWidth={false}
                disabled={isBooking || isPrefilling}
              >
                {currencies &&
                  Object.keys(currencies).map((item) => (
                    <Select.Option key={item}>{item}</Select.Option>
                  ))}
              </Select>
            )}
          </FormItem>
          <span style={{ fontStyle: 'italic', fontSize: `${tokens.fontSize.small}px`, color: '#262626', marginLeft: '6px' }}>
            Per Trailer
          </span>
        </div>
      </div>
    );
  };

  const renderAdditionalDetails = () => {
    const businessTypes: string[] = businessTypeList ? Object.values(businessTypeList) : [];
    const vehicleList = form.getFieldValue('vehicleDetails');
    const vehicleType: string | undefined = vehicleList?.length ? vehicleList[0].type : undefined;
    
    let initialTnC = termsAndConditions;
    if (trailerType && defaultMovementSpecificTnC && InquiryModes.TRAILER in defaultMovementSpecificTnC) {
      initialTnC = defaultMovementSpecificTnC?.[InquiryModes.TRAILER]?.[trailerType] ?? initialTnC;
    }
    if (vehicleType && defaultVehicleSpecificTnC && InquiryModes.TRAILER in defaultVehicleSpecificTnC) {
      initialTnC = defaultVehicleSpecificTnC?.[InquiryModes.TRAILER]?.[vehicleType] ?? initialTnC;
    }
    return (
      <Collapse
        bordered={false}
        activeKey={activeKey}
        onChange={(e) => {
          setState({ activeKey: e });
        }}
        style={{ backgroundColor: '#F9F9F9' }}
      >
        <Collapse.Panel
          header="Additional Details"
          key="1"
          style={{
            border: 'none',
          }}
          className={parentClasses.panelHeader}
        >
          <Row gutter={24} className={classes.additionalDetailsRow}>
            <Col span={10} style={{ display: 'flex', flexDirection: 'column' }}>
              <div className={parentClasses.rowDiv}>
                <div style={{ width: '25%', marginTop: '10px' }}>
                  <span className={parentClasses.formTitles}>Origin Free Days </span>
                </div>
                <FormItem style={{ marginBottom: '0px', width: '70%' }}>
                  {getFieldDecorator('originFreeDays')(
                    <InputNumber
                      style={{ width: '50%' }}
                      placeholder="Origin Free Days"
                      disabled={isPrefilling}
                    />
                  )}
                </FormItem>
              </div>
            </Col>
            <Col span={14}>
              <div className={parentClasses.rowDiv}>
                <div style={{ width: '25%', marginTop: '10px' }}>
                  <span className={parentClasses.formTitles}>Destination Free Days </span>
                </div>
                <FormItem style={{ marginBottom: '0px', width: '70%' }}>
                  {getFieldDecorator('destinationFreeDays')(
                    <InputNumber
                      style={{ width: '50%' }}
                      placeholder="Destination Free Days"
                      disabled={isPrefilling}
                    />
                  )}
                </FormItem>
              </div>
            </Col>
          </Row>
          <Row gutter={24} className={classes.additionalDetailsRow}>
            <Col span={10} style={{ display: 'flex', flexDirection: 'column' }}>
              <div className={parentClasses.rowDiv}>
                <div style={{ width: '25%', marginTop: '10px' }}>
                  <span className={parentClasses.formTitles}>Carrier Free Days </span>
                </div>
                <FormItem style={{ marginBottom: '0px', width: '70%' }}>
                  {getFieldDecorator('carrierFreeDays')(
                    <InputNumber
                      style={{ width: '30%' }}
                      placeholder="Free Days"
                      disabled={isPrefilling}
                    />
                  )}
                </FormItem>
              </div>
            </Col>
            <Col span={14}>
              <div className={parentClasses.rowDiv}>
                <div style={{ width: '25%', marginTop: '10px' }}>
                  <span className={parentClasses.formTitles}>Internal Reference No. </span>
                </div>
                <FormItem style={{ marginBottom: '0px', width: '70%' }}>
                  {getFieldDecorator('internalReference')(
                    <Input
                      style={{ width: '50%' }}
                      placeholder="Internal Reference Number"
                      disabled={isPrefilling}
                    />
                  )}
                </FormItem>
              </div>
            </Col>
          </Row>
          <Row gutter={24} className={classes.additionalDetailsRow}>
          <Col span={10} style={{ display: 'flex', flexDirection: 'column' }}>
              <div className={parentClasses.rowDiv}>
                <div style={{ width: '25%', marginTop: '10px' }}>
                  <span className={parentClasses.formTitles}>Business Type </span>
                </div>
                <FormItem style={{ marginBottom: '0px', width: '70%' }}>
                  {getFieldDecorator('trailerBusinessType')(
                    <Select
                      showSearch
                      disabled={isBooking || isPrefilling}
                      placeholder="Business Type"
                      style={{ width: '50%' }}
                      dropdownMatchSelectWidth={false}
                    >
                      {businessTypes.length && businessTypes.map((item) => {
                        return <Option key={item}>{item}</Option>;
                      })}
                    </Select>
                  )}
                </FormItem>
              </div>
            </Col>
            <Col span={14} style={{ display: 'flex', flexDirection: 'column' }}>
              <div className={parentClasses.rowDiv}>
                <div style={{ width: '25%', marginTop: '10px' }}>
                  <span className={parentClasses.formTitles}>Business Entity </span>
                </div>
                <FormItem style={{ marginBottom: '0px', width: '70%' }}>
                  {getFieldDecorator('businessEntity')(
                    <Select
                      showSearch
                      disabled={isBooking || isPrefilling}
                      placeholder="Business Entity"
                      style={{ width: '50%' }}
                      dropdownMatchSelectWidth={false}
                    >
                      {businessEntities?.map((item) => {
                        return <Option key={item}>{item}</Option>;
                      })}
                    </Select>
                  )}
                </FormItem>
              </div>
            </Col>
          </Row>
          <Row gutter={24} className={classes.additionalDetailsRow}>
            <Col span={10} style={{ display: 'flex', flexDirection: 'column' }}>
              {renderReferenceRate()}
            </Col>
            <Col span={14}>
              <div className={parentClasses.rowDiv}>
                <div style={{ width: '25%', marginTop: '10px' }}>
                  <span className={parentClasses.formTitles}>Terms &amp; Conditions </span>
                </div>
                <FormItem style={{ width: '75%' }}>
                  {getFieldDecorator('terms', {
                    initialValue: prefilledTermsAndConditions || initialTnC,
                  })(
                    <Input.TextArea
                      placeholder={termsConditionsPlaceholder}
                      style={{ width: '70%', height: '48px' }}
                      autoComplete="new-password"
                      disabled={isPrefilling}
                    />
                  )}
                </FormItem>
              </div>
            </Col>
          </Row>
          
        </Collapse.Panel>
      </Collapse>
    );
  };

  const handleRemoveVehicle = (index) => {
    const newList = form.getFieldValue('vehicleDetails');
    newList.splice(index, 1);
    setState({ vehicleDetails: newList });
    form.setFieldsValue({
      vehicleDetails: newList,
    });
  };

  const renderVehicleDetails = () => {
    const vehicleTypes = getFilterVehicleTypesSize('type');
    const vehicleSizes = getFilterVehicleTypesSize('size');
    const initialVehicleTypeValue = vehicleTypes?.length ? vehicleTypes[0]?.key?.type : "STANDARD TRAILER";
    const initialVehicleSizeValue = vehicleSizes?.length ? vehicleSizes[0]?.key?.size : "20'";
    const isDraft = form.getFieldValue('isDraft');
    const isRequired = (isDraft && draftMandatoryFields?.includes('containerDetails')) || !isDraft;
    const isEditOrBooking = !!isEdit || !!isBooking;
    return (
      <Row
        gutter={24}
        style={{
          marginBottom: '25px',
          marginRight: '10px',
          verticalAlign: 'middle',
        }}
      >
        <Col span={5} style={{ marginTop: '5px' }}>
          <span className={parentClasses.formTitles}> Vehicle details{isRequired ? <Asterisk /> : null} </span>{' '}
        </Col>
        <Col span={19}>
          {vehicleDetails?.map((item, index) => {
            return (
              <Row gutter={12} key={index}>
                <Col span={4}>
                  <FormItem style={{ marginBottom: '0px' }}>
                    {getFieldDecorator(`vehicleDetails[${index}].count`, {
                      rules: [{ required: isRequired, message: 'Required' }],
                      initialValue: isEditOrBooking? prefilledVehicleDetails[index]?.count 
                        : (getInitialVehicleDetails(index, 'count') || isRequired ? 1 : undefined),
                    })(
                    <InputNumber
                      placeholder='Count'
                      style={{ width: '100%' }}
                      min={1}
                      precision={0}
                      disabled={isBooking || isPrefilling}
                    />)}
                  </FormItem>
                </Col>
                <Col span={5} style={{ paddingLeft: 0, paddingRight: 0 }}>
                  <FormItem style={{ marginBottom: '0px' }}>
                    {getFieldDecorator(`vehicleDetails[${index}].type`, {
                      rules: [{ required: isRequired, message: 'Required' }],
                      initialValue: isEditOrBooking ? prefilledVehicleDetails[index]?.type 
                        : (getInitialVehicleDetails(index, 'type') || isRequired ? initialVehicleTypeValue : undefined),
                    })(
                      <Select
                        placeholder="Type"
                        allowClear={false}
                        style={{ width: '100%' }}
                        disabled={isBooking || isPrefilling}
                        dropdownMatchSelectWidth={false}
                      >
                        {vehicleTypes?.map((item) => (
                          <Option key={item?.key?.type} data-value={item?.label?.type}>
                            <Tooltip title={item?.label?.type}>
                              <span>{item?.label?.type}</span>
                            </Tooltip>
                          </Option>
                        ))}
                      </Select>
                    )}
                  </FormItem>
                </Col>
                <Col span={5}>
                  <FormItem style={{ marginBottom: '0px' }}>
                    {getFieldDecorator(`vehicleDetails[${index}].size`, {
                      rules: [{ required: isRequired, message: 'Required' }],
                      initialValue: isEditOrBooking ? prefilledVehicleDetails[index]?.size
                        : (getInitialVehicleDetails(index, 'size') || isRequired ? initialVehicleSizeValue : undefined),
                    })(
                      <Select
                        placeholder="Size"
                        allowClear={false}
                        style={{ width: '100%' }}
                        disabled={isBooking || isPrefilling}
                        dropdownMatchSelectWidth={false}
                      >
                        {vehicleSizes?.map((item) => (
                          <Option key={item?.key?.size} data-value={item?.label?.size}>
                            {item?.label?.size}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </FormItem>
                </Col>
                <Col span={7} className={classes.cargoColumn}
                  style={{ marginTop: '4px', backgroundColor: isBooking ? '#f5f5f5' : tokens.colors.bgWhite }}
                >
                  <FormItem style={{ width: '60%' }} className={classes.cargoFontItem}>
                    {getFieldDecorator(`vehicleDetails[${index}].weight.value`, {
                      rules: [{ required: isRequired, message: 'Required' }],
                      initialValue: isEditOrBooking ? prefilledVehicleDetails[index]?.weight?.value
                        : getInitialVehicleDetails(index, 'weight.value', isRequired ? 'roadLegal' : undefined),
                    })(
                      <InputNumber
                        placeholder="Weight"
                        size="small"
                        disabled={isBooking || isPrefilling}
                        style={{ width: '100%', border: 'none', boxShadow: 'none' }}
                        min={1}
                      />
                    )}
                  </FormItem>
                  <FormItem style={{ width: '40%' }} className={classes.cargoFontItem}>
                    {getFieldDecorator(`vehicleDetails[${index}].weight.unit`, {
                      rules: [{ required: isRequired, message: 'Required' }],
                      initialValue: isEditOrBooking ? prefilledVehicleDetails[index]?.weight?.unit
                        : (getInitialVehicleDetails(index, 'weight.unit') || 'mt'),
                    })(
                      <Select
                        placeholder="Type"
                        allowClear={false}
                        size="small"
                        disabled={isBooking || isPrefilling}
                        style={{ width: '100%' }}
                        className={classes.selectBorder}
                        dropdownMatchSelectWidth={false}
                      >
                        {weightsUnits?.map((unit) => {
                          // Skipping "cases" unit as it is required only in containerUnits
                          if (EXCLUDED_WEIGHT_UNITS.includes(unit)) {
                            return null;
                          } else {
                            return (
                              <Option key={unit}>{unit}</Option>
                            );
                          }
                        })}
                      </Select>
                    )}
                  </FormItem>
                </Col>
                <Col span={1}>
                  {(!isBooking &&
                    vehicleDetails?.length !== 1 && index !== vehicleDetails?.length - 1) && <Icon type="close"
                    style={{ color: 'red', marginTop: '12px' }}
                    onClick={() => handleRemoveVehicle(index)}
                  />}
                </Col>
              </Row>
            );
          })}
          {!isBooking && <Row>
            <Col style={{ paddingTop: '10px', color: tokens.colors.primary }}>
              <Icon
                type="plus"
                style={{
                  height: '12px',
                  width: '12px',
                  margin: '4px 4px 0 0',
                }}
              />
              <a
                type="plus-circle"
                style={{
                  cursor: 'pointer',
                  fontSize: `${tokens.fontSize.small}px`,
                }}
                onClick={() => handleAddMore()}
              >
                Add More
              </a>
            </Col>
          </Row>}
        </Col>
      </Row>
    );
  };

  const handleAddMore = () => {
    const newList = [
      ...vehicleDetails,
      {},
    ];
    setState({ vehicleDetails: newList });
  };

  const renderPickupPortDetails = () => {
    const isDraft = form.getFieldValue('isDraft');
    const isRequired = (isDraft && draftMandatoryFields?.includes('emptyContainerLocationId')) || !isDraft;
    
    return (
      <Timeline.Item
        style={{ marginTop: '8px' }}
        dot={<div className={[classes.dot, classes.dotFilled].join(' ')}></div>}
      >
        <Row>
          <Col span={7} style={{ marginTop: '5px' }}>
            <span className={parentClasses.formTitles}> Container Pickup{isRequired ? <Asterisk /> : null} </span>{' '}
          </Col>
          <Col
            span={17}
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <FormItem style={{ marginBottom: '8px', width: '70%' }}>
              {getFieldDecorator('pickupPort', {
                rules: [{ required: isRequired, message: 'Pickup Port Required' }],
              })(
                <Select
                  allowClear
                  disabled={isBooking || isPrefilling}
                  showSearch
                  optionLabelProp={'data-value'}
                  labelInValue
                  filterOption={(input, option) => true}
                  onSearch={(searchTerm) => setState({ searchTerm })}
                  onFocus={() => setState({ searchTerm: '' })}
                  dropdownRender={menu => renderSelectDropDown(menu, isPortSearching)}
                  dropdownMatchSelectWidth={false}
                  placeholder="Container Pickup Port"
                  onChange={(port: KeyLabel) => {
                    !form.getFieldValue('stuffingAddress') &&
                    !form.getFieldValue('dropOffPort') &&
                    setState({ countrySelected: JSON.parse(port?.key || '{}')?.countryId });
                    if (getFieldValue('containerDropOffCheck') && trailerType === InquiryType.EXPORT) {
                      setFieldsValue({ dropOffPort: {
                        key: port?.key,
                        label: port?.label,
                      }});
                    }
                  }}
                >
                  {ports?.map((item) => {
                    return (
                      <Option key={item.id} data-value={`${item.name} [${item.code}]`}>
                        <div>
                          <span
                            style={{ marginRight: '5px' }}
                          >{`${item.name} [${item.code}]`}</span>
                          {item.type === 'DRY' && (
                            <button
                              style={{
                                float: 'right',
                                fontSize: '9px',
                                borderRadius: `${tokens.radius.md}px`,
                                display: 'flex',
                                alignContent: 'center',
                                alignItems: 'center',
                                alignSelf: 'center',
                              }}
                            >
                              ICD
                            </button>
                          )}
                        </div>
                      </Option>
                    );
                  })}
                </Select>
              )}
            </FormItem>
          </Col>
        </Row>
      </Timeline.Item>
    );
  };

  const getAddress = async (props) => {
    const {
      locationList,
      addressType,
      addressList
    } = props;
    setState({ isAddressLoading: true });
    const response = await fetchAddresses({
      locationList,
      addressType,
      countryIdList: countrySelected ? [countrySelected] : [],
    });
    if (response.isSuccess) {
      setState({
        [`${addressList}`]: response.data?.filter((item) => !!item?.address),
        isAddressLoading: false,
      })
    } else {
      message.error(response.errorMessage);
      setState({
        isAddressLoading: false,
      })
    }
  }

  const renderCFSLocation = () => {
    const { 
      enableAddressMasterInMenu, 
      permissions 
    } = props;
    const isDraft = form.getFieldValue('isDraft');
    const isRequired = (isDraft && draftMandatoryFields?.includes('originLocationId')) || !isDraft;
    return (
      <Timeline.Item
        style={{ marginTop: '8px' }}
        dot={<div className={[classes.dot, classes.dotFilled].join(' ')}></div>}
      >
        <Row>
          <Col span={7} style={{ marginTop: '5px' }}>
            <span className={parentClasses.formTitles}>Container Pickup{isRequired ? <Asterisk /> : null}</span>{' '}
            <div className={classes.fontItalic}>(Origin)</div>
          </Col>
          <Col span={17}>
            <FormItem style={{ marginBottom: '8px', width: '70%' }}>
              {getFieldDecorator('cfsLocation', {
                rules: [{ required: isRequired, message: 'CFS Location Required' }],
              })(
                <SelectAddress
                  placeholder="Select CFS Location"
                  shipperId={(isEdit || isBooking) ? shipperId : organisationId}
                  cargoOperationType= {CargoOperationType.DESTUFFING}
                  locationType={LocationType.CFS}
                  disabled={isBooking || isPrefilling}
                  allowEdit={
                    enableAddressMasterInMenu
                      ? hasMasterCategoryEditPermission('ADDRESS', permissions)
                      : true
                  }

                  detailed= {true}
                  labelInValue = {true}
                  addresses={cfsAddresses}
                  onChange={(item, option: any) => {
                    !form.getFieldValue('deStuffingAddress') &&
                    !form.getFieldValue('dropOffPort') &&
                    setState({ countrySelected: option?.props?.countryId });
                    setState({
                      cfsLocation: option ? {
                        city: option.props?.city,
                        countryId: option.props?.countryId,
                        address: option.props?.address,
                        state: option.props?.state,
                        pincode: option.props?.pincode,
                        name: option.props?.name,
                      } : undefined,
                    });
                  }}
                  
                >
                </SelectAddress>
              )}
            </FormItem>
            {renderAddressDetails({
              classes,
              orgMaster,
              item: cfsLocation,
              style: { fontSize: `${tokens.fontSize.small}px`, width: '70%' },
            })}
          </Col>
        </Row>
      </Timeline.Item>
    );
  };
  const renderStuffingOrDeStuffingAddress = (fieldLabel, fieldArray, isStuffing, addressType, apiKey) => {
    const {
      enableAddressMasterInMenu,
      permissions
    } = props
    const isDraft = form.getFieldValue('isDraft');
    const isRequired = (isDraft && draftMandatoryFields?.includes(apiKey)) || !isDraft;
    
    return (
      <Timeline.Item dot={<div className={[classes.dot, classes.dotFilled].join(' ')}></div>}>
        <Row>
          <Col span={7} style={{ marginTop: '5px' }}>
            <span className={parentClasses.formTitles}>
              {isStuffing ? 'Stuffing Location' : 'De-Stuffing Location'}{' '}{isRequired ? <Asterisk /> : null}
            </span>{' '}
            <div className={classes.fontItalic}>{isStuffing ? '(Origin)' : '(Destination)'}</div>
          </Col>
          <Col span={17}>
            <FormItem style={{ marginBottom: '8px', width: '70%' }}>
              {getFieldDecorator(fieldLabel, {
                rules: [
                  {
                    required: isRequired,
                    message: isStuffing
                      ? 'Stuffing Location Required'
                      : 'De-Stuffing Location Required',
                  },
                ],
              })(
                <SelectAddress
                  placeholder={
                    isStuffing ? 'Select Stuffing Location' : 'Select De-Stuffing Location'
                  }
                  addresses={isStuffing ? stuffingAddresses : deStuffingAddresses}
                  cargoOperationType={isStuffing ? CargoOperationType.STUFFING : CargoOperationType.DESTUFFING}
                  allowEdit={
                    enableAddressMasterInMenu
                      ? hasMasterCategoryEditPermission('ADDRESS', permissions)
                      : true
                  }

                  detailed={true}
                  labelInValue = {true}
                  disabled={isBooking || isPrefilling}
                  onChange={(item, option: any) => {
                    !form.getFieldValue('cfsLocation') &&
                    !form.getFieldValue('dropOffPort') &&
                    !form.getFieldValue('pickupPort') &&
                    setState({ countrySelected: option?.props?.countryId });
                    setStuffingTruckingAddress(option ? {
                      city: option.props?.city,
                      countryId: option.props?.countryId,
                      address: option.props?.address,
                      state: option.props?.state,
                      pincode: option.props?.pincode,
                      name: option.props?.name,
                    } : undefined);
                  }}
                >
                </SelectAddress>
              )}
            </FormItem>
            {renderAddressDetails({
              classes,
              orgMaster,
              item: stuffingAddressObj,
              style: { fontSize: `${tokens.fontSize.small}px`, width: '70%' },
            })}
          </Col>
        </Row>
      </Timeline.Item>
    );
  };

  const renderDropOffPortDetails = () => {
    const disableDropOff = (getFieldValue('containerDropOffCheck') && trailerType === InquiryType.EXPORT) ||
      isBooking;
    const isDraft = form.getFieldValue('isDraft');
    const isRequired = (isDraft && draftMandatoryFields?.includes(
      trailerType === InquiryType.EXPORT ? 'destination' : 'emptyContainerLocationId'
    )) || !isDraft;
    
    return (
      <Timeline.Item dot={<div className={[classes.dot, classes.dotFilled].join(' ')}></div>}>
        <Row>
          <Col span={7} style={{ marginTop: '5px' }}>
            <span className={parentClasses.formTitles}> Container Drop Off{isRequired ? <Asterisk /> : null} </span>{' '}
            {trailerType === InquiryType.EXPORT && <div className={classes.fontItalic}>(Destination)</div>}
          </Col>
          <Col span={17} style={{ lineHeight: '20px' }}>
            <FormItem style={{ width: '70%', marginBottom: 0 }}>
              {getFieldDecorator('dropOffPort', {
                rules: [
                  {
                    required: !disableDropOff && isRequired,
                    message: 'Drop Off Port Required',
                  },
                ],
              })(
                <Select
                  allowClear
                  showSearch
                  disabled={disableDropOff || isPrefilling}
                  dropdownMatchSelectWidth={false}
                  optionLabelProp={'data-value'}
                  labelInValue
                  onSearch={(searchTerm) => setState({ searchTerm })}
                  onFocus={() => setState({ searchTerm: '' })}
                  dropdownRender={menu => renderSelectDropDown(menu, isPortSearching)}
                  placeholder="Container Drop Off Port"
                  onChange={(port: KeyLabel) => {
                    !form.getFieldValue('deStuffingAddress') &&
                    !form.getFieldValue('cfsLocation') &&
                    !form.getFieldValue('pickupPort') &&
                    !form.getFieldValue('stuffingAddress') &&
                    setState({ countrySelected: JSON.parse(port?.key || '{}')?.countryId });
                  }}
                >
                  {ports?.map((item, index) => {
                    return (
                      <Option key={item.id} data-value={`${item.name} [${item.code}]`}>
                        <div>
                          <span
                            style={{ marginRight: '5px' }}
                          >{`${item.name} [${item.code}]`}</span>
                          {item.type === 'DRY' && (
                            <button
                              style={{
                                float: 'right',
                                fontSize: '9px',
                                borderRadius: `${tokens.radius.md}px`,
                                display: 'flex',
                                alignContent: 'center',
                                alignItems: 'center',
                                alignSelf: 'center',
                              }}
                            >
                              ICD
                            </button>
                          )}
                        </div>
                      </Option>
                    );
                  })}
                </Select>
              )}
            </FormItem>
            {trailerType === InquiryType.EXPORT && (
              <FormItem style={{margin: '-10px 8px'}}>
                {getFieldDecorator('containerDropOffCheck', {
                  initialValue: false,
                  valuePropName: 'checked',
                })(
                  <Checkbox onChange={e => {
                    if (e.target.checked) {
                      setFieldsValue({ dropOffPort: getFieldValue('pickupPort') })
                    }
                  }}
                  disabled={isBooking || isPrefilling}>
                    <span
                      className={classes.checkboxFont}
                    >Same as Pickup Location</span>
                  </Checkbox>
                )}
              </FormItem>
            )}
          </Col>
        </Row>
      </Timeline.Item>
    );
  };
  return (
    <>
      {isPrefilling && (
        <div
          style={{
            height: '100%',
            width: '100%',
            textAlign: 'center',
            top: '30%',
            zIndex: 1000,
            position: 'absolute',
          }}
        >
          <Spin size="large" />
        </div>
      )}
      <Row
        gutter={24}
        style={{
          verticalAlign: 'middle',
          margin: '30px 30px 0 0',
        }}
      >
        <Col span={18}>
          <Timeline className={parentClasses.antTimeline}>
            {trailerType === InquiryType.EXPORT ? renderPickupPortDetails() : renderCFSLocation()}
            {trailerType === InquiryType.EXPORT
              ? renderStuffingOrDeStuffingAddress('stuffingAddress', stuffingAddresses, true, 'STUFFING', 'originLocationId')
              : renderStuffingOrDeStuffingAddress('deStuffingAddress', deStuffingAddresses, false, 'DESTUFFING', 'destinationLocationId')}
            {renderDropOffPortDetails()}
          </Timeline>
        </Col>
        <Col span={15}>
          {renderVehicleDetails()}
          {renderCargoDetails()}
          {renderCargoReadyOrClosingTime('Cargo Ready Date', 'cargoDate', 'cargoReadyDate')}
          {renderContractDuration()}
          {!isBooking && renderCargoReadyOrClosingTime(
            'Inquiry Closing Time',
            'closingTime',
            'deadline',
            defaultDeadlineInHours ?
              moment().add(defaultDeadlineInHours, 'hours') :
              moment().endOf('day').add(2, 'day'))
          }
          {isGensetRequired !== undefined && (
            <>
              {renderGensetRequired()}
              {renderOverWeight()}
            </>
          )}
          {customFieldsForInquiryTrailer?.shipmentName && renderCustomTextField(
            customFieldsForInquiryTrailer?.shipmentName?.prettyName || 'Shipment Name',
            'shipmentName',
            (getFieldValue('isDraft') && draftMandatoryFields?.includes('shipmentName')) || 
            (!getFieldValue('isDraft') && customFieldsForInquiryTrailer?.shipmentName?.isMandatory) || 
            false,
            customFieldsForInquiryTrailer?.shipmentName?.default || undefined,
          )}
          {customFieldsForInquiryTrailer?.requestor && renderCustomTextField(
            customFieldsForInquiryTrailer?.requestor?.prettyName || 'Requestor',
            'requestor',
            (getFieldValue('isDraft') && draftMandatoryFields?.includes('requestor')) || 
            (!getFieldValue('isDraft') && customFieldsForInquiryTrailer?.requestor?.isMandatory) || 
            false,
            customFieldsForInquiryTrailer?.requestor?.default || undefined,
          )}
          {customFieldsForInquiryTrailer?.serviceLevel && renderCustomDropDown(
            customFieldsForInquiryTrailer?.serviceLevel?.prettyName || 'Service Level',
            'serviceLevel',
            customFieldsForInquiryTrailer?.serviceLevel?.dropDown || [],
            (getFieldValue('isDraft') && draftMandatoryFields?.includes('serviceLevel')) || 
            (!getFieldValue('isDraft') && customFieldsForInquiryTrailer?.serviceLevel?.isMandatory) || 
            false,
            customFieldsForInquiryTrailer?.serviceLevel?.default || undefined,
          )}
          {customFieldsForInquiryTrailer?.typeOfMovement && renderCustomDropDown(
            customFieldsForInquiryTrailer?.typeOfMovement?.prettyName || 'Type of Import/Export',
            'typeOfMovement',
            customFieldsForInquiryTrailer?.typeOfMovement?.dropDown || [],
            (getFieldValue('isDraft') && draftMandatoryFields?.includes('typeOfMovement')) || 
            (!getFieldValue('isDraft') && customFieldsForInquiryTrailer?.typeOfMovement?.isMandatory) || 
            false,
            customFieldsForInquiryTrailer?.typeOfMovement?.default || undefined,
          )}
          {(getFieldValue('isDraft') && customFieldsForInquiryTrailer?.isDraftIncomplete) && renderCustomRadio(
            customFieldsForInquiryTrailer?.isDraftIncomplete?.prettyName || 'Draft Incomplete',
            'isDraftIncomplete',
            (getFieldValue('isDraft') && draftMandatoryFields?.includes('isDraftIncomplete')) || 
            (!getFieldValue('isDraft') && customFieldsForInquiryTrailer?.isDraftIncomplete?.isMandatory) || 
            false,
            customFieldsForInquiryTrailer?.isDraftIncomplete?.default || undefined,
          )}
          {(getFieldValue('isDraft') && customFieldsForInquiryTrailer?.remarks) && renderCustomTextField(
            customFieldsForInquiryTrailer?.remarks?.prettyName || 'Remarks',
            'remarks',
            (getFieldValue('isDraft') && draftMandatoryFields?.includes('remarks')) || 
            (!getFieldValue('isDraft') && customFieldsForInquiryTrailer?.remarks?.isMandatory) || 
            false,
            customFieldsForInquiryTrailer?.remarks?.default || undefined,
          )}
        </Col>
        <Col>
        
        </Col>
      </Row>
      {renderAdditionalDetails()}
      {openNewLocationModal && (
        <AddLocationModal
          visible={openNewLocationModal}
          handleCancel={() => setState({ openNewLocationModal: false })}
          loadAddresses={loadAddresses}
          showLocationInput={true}
        />
      )}
      {openCFSLocationModal && (
        <AddCfsLocationModal
          visible={openCFSLocationModal}
          handleCancel={() => setState({ openCFSLocationModal: false })}
          loadAddresses={loadAddresses}
        />
      )}
    </>
  );
};

const mapStateToProps = ({ masterData, inquiryReducer, organisation }, ownProps) => ({
  cargoTypes: masterData.cargoTypeList,
  cargoList: masterData.cargoList,
  currencies: masterData.currencySymbols,
  orgMaster: organisation.orgMaster,
  organisationId: organisation.orgDetails.organisationId,
  orgCurrency: organisation?.orgDetails?.defaultCurrency ?? 'USD',
  vehicleTypeSizeList: masterData.vehicleTypeSizeList,
  weightsUnits: inquiryReducer.masterData.weightsUnits,
  businessEntities: inquiryReducer.masterData.businessEntities,
  businessTypeList: inquiryReducer.masterData.businessTypeList,
  termsAndConditions: inquiryReducer.masterData.termsAndConditions,
  isTemperatureControlledMandatory: masterData.modules.is_temperature_controlled_mandatory,
  reeferProductTempRange: inquiryReducer.masterData.reeferProductTempRange,
  defaultDeadlineInHours: inquiryReducer.masterData.defaultDeadlineInHours,
  defaultVehicleSpecificTnC: masterData?.inquiryDefaults?.defaultVehicleSpecificTnC,
  defaultMovementSpecificTnC: masterData?.inquiryDefaults?.defaultMovementSpecificTnC,
  defaultWeights: masterData?.inquiryDefaults?.defaultWeights,
  isGensetRequired: masterData?.customFieldsForInquiry?.TRAILER?.isGensetRequired,
  customFieldsForInquiryTrailer: masterData?.customFieldsForInquiry?.TRAILER, 
  draftMandatoryFields: masterData?.mandatoryFieldsInInquiryDraft?.TRAILER,
  permissions: masterData.permissions,
  enableAddressMasterInMenu: masterData.modules.enable_address_master_in_menu || false,
});

export default (connect(
  mapStateToProps,
  null,
  )(Form.create()(withStyles(styles)(React.memo(CreateTruckingInquiry))))
);